import React from 'react';

import { Button, Dialog, DialogContent } from '@material-ui/core';

import { DialogTitle } from 'components';
import { getTemplateTypes } from 'templates';

const CreateDialog = ({ open, onClose, onSelect }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle onClose={onClose}>Pick a type</DialogTitle>

    <DialogContent>
      {getTemplateTypes().map(({ text, value }) => (
        <Button
          key={value}
          color="primary"
          variant="contained"
          onClick={() => onSelect(value)}
          style={{ margin: 8 }}
        >
          {text}
        </Button>
      ))}
    </DialogContent>
  </Dialog>
);

export default CreateDialog;
